var render = function render(){var _vm=this,_c=_vm._self._c;return (this.token !== '')?_c('user'):_c('auth')
}
var staticRenderFns = []

export { render, staticRenderFns }